/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateCurrencyDto } from '../models';
// @ts-ignore
import type { CurrencyDto } from '../models';
/**
 * CurrenciesApi - axios parameter creator
 * @export
 */
export const CurrenciesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<CreateCurrencyDto>} createCurrencyDto Array of currencies to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currenciesControllerCreateCurrency: async (createCurrencyDto: Array<CreateCurrencyDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCurrencyDto' is not null or undefined
            assertParamExists('currenciesControllerCreateCurrency', 'createCurrencyDto', createCurrencyDto)
            const localVarPath = `/api/currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCurrencyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currenciesControllerGetCurrencies: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<CreateCurrencyDto>} createCurrencyDto Array of currencies to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currenciesControllerPatchCurrencies: async (createCurrencyDto: Array<CreateCurrencyDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCurrencyDto' is not null or undefined
            assertParamExists('currenciesControllerPatchCurrencies', 'createCurrencyDto', createCurrencyDto)
            const localVarPath = `/api/currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCurrencyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CurrenciesApi - functional programming interface
 * @export
 */
export const CurrenciesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CurrenciesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<CreateCurrencyDto>} createCurrencyDto Array of currencies to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currenciesControllerCreateCurrency(createCurrencyDto: Array<CreateCurrencyDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currenciesControllerCreateCurrency(createCurrencyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CurrenciesApi.currenciesControllerCreateCurrency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currenciesControllerGetCurrencies(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CurrencyDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currenciesControllerGetCurrencies(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CurrenciesApi.currenciesControllerGetCurrencies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<CreateCurrencyDto>} createCurrencyDto Array of currencies to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currenciesControllerPatchCurrencies(createCurrencyDto: Array<CreateCurrencyDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currenciesControllerPatchCurrencies(createCurrencyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CurrenciesApi.currenciesControllerPatchCurrencies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CurrenciesApi - factory interface
 * @export
 */
export const CurrenciesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CurrenciesApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<CreateCurrencyDto>} createCurrencyDto Array of currencies to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currenciesControllerCreateCurrency(createCurrencyDto: Array<CreateCurrencyDto>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.currenciesControllerCreateCurrency(createCurrencyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currenciesControllerGetCurrencies(options?: RawAxiosRequestConfig): AxiosPromise<Array<CurrencyDto>> {
            return localVarFp.currenciesControllerGetCurrencies(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<CreateCurrencyDto>} createCurrencyDto Array of currencies to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currenciesControllerPatchCurrencies(createCurrencyDto: Array<CreateCurrencyDto>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.currenciesControllerPatchCurrencies(createCurrencyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CurrenciesApi - object-oriented interface
 * @export
 * @class CurrenciesApi
 * @extends {BaseAPI}
 */
export class CurrenciesApi extends BaseAPI {
    /**
     * 
     * @param {Array<CreateCurrencyDto>} createCurrencyDto Array of currencies to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrenciesApi
     */
    public currenciesControllerCreateCurrency(createCurrencyDto: Array<CreateCurrencyDto>, options?: RawAxiosRequestConfig) {
        return CurrenciesApiFp(this.configuration).currenciesControllerCreateCurrency(createCurrencyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrenciesApi
     */
    public currenciesControllerGetCurrencies(options?: RawAxiosRequestConfig) {
        return CurrenciesApiFp(this.configuration).currenciesControllerGetCurrencies(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<CreateCurrencyDto>} createCurrencyDto Array of currencies to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrenciesApi
     */
    public currenciesControllerPatchCurrencies(createCurrencyDto: Array<CreateCurrencyDto>, options?: RawAxiosRequestConfig) {
        return CurrenciesApiFp(this.configuration).currenciesControllerPatchCurrencies(createCurrencyDto, options).then((request) => request(this.axios, this.basePath));
    }
}

